import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { Mode, ROUTE_PATH } from '@core/constants';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})

export class NavService {

  _mode: number = Mode.WEB;

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
  ){ this._mode = this.getMode() }

  private getMode(): number {
    return this.localStorageService.getItem(LOCAL_STORAGE_KEY.mode) || Mode.WEB;
  }

  navHome(){ this.router.navigateByUrl('/', { replaceUrl: true }) }
  navCustLogin(){ this.router.navigateByUrl(ROUTE_PATH.CUST_LOGIN, { replaceUrl: true }) }
  navStaffLogin(){ return this.router.navigateByUrl(ROUTE_PATH.LOGIN, { replaceUrl: true }) }
  navCorpSelect(){ return this.router.navigateByUrl(ROUTE_PATH.CORP_SELECTION, { replaceUrl: true }) }
  navOffieSelect(){ 
    const mode = this.getMode();
    if(mode == Mode.WEB) this.router.navigateByUrl(ROUTE_PATH.OFFICE_SELECTION, { replaceUrl: true });
    else if(mode == Mode.TV) this.router.navigateByUrl(ROUTE_PATH.TV_OFFICE_SELECTION, { replaceUrl: true });
  }
  navCheckSheet(){
    const mode = this.getMode();
    if(mode == Mode.WEB) this.router.navigateByUrl(ROUTE_PATH.CHECK_SHEET, { replaceUrl: true });
    else if(mode == Mode.TV) {
      const returnUrl = `/${ROUTE_PATH.TV_BLANK}`;
      this.router.navigateByUrl(`/${ROUTE_PATH.TV_STARTUP}?returnUrl=${encodeURIComponent(returnUrl)}`, { replaceUrl: true });
    }
  }
  navUserDashBoard(){ 
    const mode = this.getMode();
    if(mode == Mode.WEB) this.router.navigateByUrl(ROUTE_PATH.USER_DASHBOARD, { replaceUrl: true });
    else if(mode == Mode.TV) this.router.navigateByUrl(ROUTE_PATH.TV_USER_DASHBOARD_DETAIL, { replaceUrl: true });
  }

}
